import { render, staticRenderFns } from "./OperationFormCard.vue?vue&type=template&id=0fc585b2&scoped=true&"
import script from "./OperationFormCard.vue?vue&type=script&lang=js&"
export * from "./OperationFormCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc585b2",
  null
  
)

export default component.exports